import { WeeklyChartProps } from './index';
import { weekStart, fmtHrs } from '@/lib/time';

export type UseHooksParams = WeeklyChartProps;

interface WeekGroup {
  weekKey: string;
  label: string;
  hours: number;
  displayHours: string;
  percentage: number;
}

export const useHooks = ({ dayMap }: UseHooksParams) => {
  const weeklyTotals: Record<string, number> = {};
  
  for (const [dateStr, hrs] of Object.entries(dayMap)) {
    const monday = weekStart(dateStr);
    weeklyTotals[monday] = (weeklyTotals[monday] || 0) + hrs;
  }
  
  const sortedWeeks = Object.entries(weeklyTotals)
    .sort((a, b) => b[0].localeCompare(a[0]));
    
  const maxHours = sortedWeeks.reduce((max, [, hrs]) => Math.max(max, hrs), 0);
  
  const chartItems: WeekGroup[] = sortedWeeks.map(([monday, hrs]) => {
    const parts = monday.split('-');
    const label = `Wk ${parts[1]}-${parts[2]}`;
    const percentage = maxHours > 0 ? (hrs / maxHours) * 100 : 0;
    
    return {
      weekKey: monday,
      label,
      hours: hrs,
      displayHours: fmtHrs(hrs),
      percentage
    };
  });
  
  return {
    chartItems
  };
};
